import * as WpsRuntime from 'DVWebNodeWpsRuntime'

export function isType<T extends WpsRuntime.coralclient.StructProps>(
  base?: T,
  expectedType?: string
) {
  return Boolean(base && base.__type === expectedType)
}
